import { useState } from 'react'
import Loading from '../Loading/Loading'
import { postEvaluation } from '../../API/Employee/Employee'

export function CreateEvaluation({ show, setShow, onCreated }) {
	const [errorMessage, setErrorMessage] = useState('')
	const [loading, setLoading] = useState(false)
	const [evaluationName, setEvaluationName] = useState('')
	const [actual, setActual] = useState(false)

	const validForm = () => {
		return !!evaluationName
	}

	const handleSubmit = async () => {
		try {
			setLoading(true)
			setErrorMessage('')

			const sendData = {
				name: evaluationName,
				actual: actual,
				companyId: JSON.parse(localStorage.getItem('user')).id,
				closed: false,
			}

			await postEvaluation(sendData)

			setShow(false)

			if (onCreated) {
				onCreated()
			}
		} catch (error) {
			const message = error?.message || 'Erro inesperado'
			setErrorMessage(message)
		} finally {
			setLoading(false)
		}
	}

	if (!show) return <></>

	return (
		<div className='tw-flex tw-items-center tw-justify-center tw-z-50 tw-absolute tw-top-0 tw-left-0 tw-w-screen tw-h-screen tw-bg-black/50 tw-backdrop-blur-sm'>
			<div className='tw-bg-white tw-w-[50%] tw-rounded-lg tw-shadow-md tw-p-5'>
				{loading ? (
					<Loading />
				) : errorMessage ? (
					<div className='tw-flex tw-flex-col tw-items-center tw-text-center'>
						<div className='tw-font-semibold tw-text-lg'>Error to register/create position.</div>
						<div className=''>Por favor, inténtalo de nuevo o contacta con nuestro soporte.</div>
						<div className='tw-flex tw-justify-end tw-gap-2 tw-mt-5'>
							<button
								className='tw-p-2 border-0 tw-rounded-lg tw-bg-gray-100 hover:tw-bg-gray-300 tw-cursor-pointer'
								onClick={() => {
									setShow(false)
									setErrorMessage('')
								}}
							>
								Cerrar
							</button>
						</div>
					</div>
				) : (
					<>
						<div className='tw-mb-4'>
							<label className='tw-block tw-text-lg tw-font-medium tw-text-gray-700'>Nombre de la Evaluación</label>
							<input
								type='text'
								value={evaluationName}
								onChange={e => setEvaluationName(e.target.value)}
								className='tw-mt-1 tw-block tw-w-full tw-p-2 border-1 d focus:tw-outline-none tw-rounded-none focus:tw-ring-2 focus:tw-ring-purple-500'
								placeholder='Digite o nome da avaliação'
							/>
						</div>

						<div className='tw-mb-4 tw-mt-5 tw-flex tw-items-center tw-gap-2'>
							<input
								type='checkbox'
								id='actual'
								checked={actual}
								onChange={e => setActual(e.target.checked)}
								className='tw-form-checkbox tw-h-4 tw-w-4 tw-text-purple-600 tw-cursor-pointer'
							/>
							<label htmlFor='actual' className='tw-text-base tw-text-gray-700'>
								Evaluación actual
							</label>
						</div>

						<div className='tw-flex tw-justify-end tw-gap-2 tw-mt-5'>
							<div className='tw-p-2 tw-cursor-pointer tw-bg-gray-100 hover:tw-bg-gray-300 tw-rounded-lg' onClick={() => setShow(false)}>
								Cancelar
							</div>
							<button
								className={`tw-p-2 tw-rounded-lg tw-text-white border-0
									${validForm() ? 'tw-bg-purple-500 hover:tw-bg-purple-700 tw-cursor-pointer' : 'tw-bg-gray-400'}`}
								onClick={validForm() ? handleSubmit : undefined}
								disabled={!validForm()}
							>
								Crear
							</button>
						</div>
					</>
				)}
			</div>
		</div>
	)
}
